import _ from "lodash";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import {
  addCoachingNotesListReq,
  addCoachingNotesListReqResponseClear,
  getCoachingNotesListReq,
} from "../../redux/user/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import Loader from "../Loader/Loader";
import { useTranslation } from "react-i18next";

const CoachAddModal = (props) => {
  const {
    showAddCoachModal,
    setShowAddCoachModal,
    coachObj,
    refreshList,
    timezone,
  } = props;
  const { t } = useTranslation();
  let hour = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];
  let min = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    ,
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ];
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const section = params.get("section");
  const user_id = params.get("user_id");
  const isOther =
    localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1"; //params.get("isOther");

  const dispatch = useDispatch();

  const addCoachingNotesListRes = useSelector(
    (state) => state.user.addCoachingNotesList
  );

  const [startDate, setStartDate] = useState(
    _.isEmpty(coachObj) ? "" : new Date(Number(coachObj.start_date) * 1000)
  );
  const [followUpDate, setFollowUpDate] = useState(
    _.isEmpty(coachObj) ? "" : new Date(Number(coachObj.follow_up) * 1000)
  );
  const [fromTime, setFromTime] = useState(
    _.isEmpty(coachObj)
      ? ""
      : moment.unix(coachObj.followup_start_dt).tz(timezone).format("HH:mm")
  );
  const [toTime, setToTime] = useState(
    _.isEmpty(coachObj)
      ? ""
      : moment.unix(coachObj.followup_end_dt).tz(timezone).format("HH:mm")
  );

  const [startHour, setStartHour] = useState(
    _.isEmpty(coachObj)
      ? "00"
      : moment
          .unix(coachObj.followup_start_dt)
          .tz(timezone)
          .format("HH:mm")
          ?.split(":")[0]
  );
  const [startMin, setStartMin] = useState(
    _.isEmpty(coachObj)
      ? "00"
      : moment
          .unix(coachObj.followup_start_dt)
          .tz(timezone)
          .format("HH:mm")
          ?.split(":")[1]
  );
  const [endHour, setEndHour] = useState(
    _.isEmpty(coachObj)
      ? "00"
      : moment
          .unix(coachObj.followup_end_dt)
          .tz(timezone)
          .format("HH:mm")
          ?.split(":")[0]
  );
  const [endMin, setEndMin] = useState(
    _.isEmpty(coachObj)
      ? "00"
      : moment
          .unix(coachObj.followup_end_dt)
          .tz(timezone)
          .format("HH:mm")
          ?.split(":")[1]
  );

  const [title, setTitle] = useState(_.isEmpty(coachObj) ? "" : coachObj.title);
  const [followUpTitle, setFollowUpTitle] = useState(
    _.isEmpty(coachObj) ? "" : coachObj.followup_title
  );
  const [notes, setNotes] = useState(_.isEmpty(coachObj) ? "" : coachObj.notes);

  const [isFetching, setIsFetching] = useState(false);
  const [isEdit, setIsEdit] = useState(isOther === "1" ? true : false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorType, setErrorType] = useState("");

  const addNotes = () => {
    console.log("datas: ", startDate, followUpDate, title, notes);
    setErrorType("");
    setErrorMsg("");

    if (_.isEmpty(title?.trim())) {
      setErrorType("title");
      setErrorMsg("Enter coaching title.");
      return;
    }

    if (startDate === undefined || startDate === "") {
      setErrorType("startDate");
      setErrorMsg("Please select date.");
      return;
    }

    if (_.isEmpty(followUpTitle?.trim())) {
      setErrorType("followTitle");
      setErrorMsg("Enter follow-up title.");
      return;
    }

    if (followUpDate === undefined || followUpDate === "") {
      setErrorType("followDate");
      setErrorMsg("Please select follow-up date.");
      return;
    }

    if (moment(startDate).diff(followUpDate) > 0) {
      setErrorType("dateValidation");
      setErrorMsg("Follow-up Date should be later than the Start Date.");
      return;
    }

    let fromTime = startHour + ":" + startMin;
    let toTime = endHour + ":" + endMin;

    if (
      fromTime === undefined ||
      fromTime === "" ||
      toTime === undefined ||
      toTime === ""
    ) {
      setErrorType("dateValidation");
      setErrorMsg("Start time and End time should not be empty.");
      return;
    }

    let from = new Date(
      moment(followUpDate).format("MM-DD-YYYY") + " " + fromTime
    );
    let to = new Date(moment(followUpDate).format("MM-DD-YYYY") + " " + toTime);
    if (to.getTime() <= from.getTime()) {
      setErrorType("dateValidation");
      setErrorMsg("End time should be later than the Start time.");
      return;
    }

    if (_.isEmpty(notes)) {
      setErrorType("notes");
      setErrorMsg("Please add coaching note.");
      return;
    }

    let req = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      user_id:
        isOther === "1" ? user_id : localStorage.getItem(SessionKeys.USER_ID),
      coach_uid: localStorage.getItem(SessionKeys.USER_ID),
      title: title,
      start_date: moment(startDate).format("DD-MM-YYYY"),
      followup_title: followUpTitle,
      follow_up: moment(followUpDate).format("DD-MM-YYYY"),
      follow_start_time: fromTime,
      follow_end_time: toTime,
      notes: notes,
    };
    if (!_.isEmpty(coachObj)) {
      req.id = coachObj.id;
    }
    setIsFetching(true);
    dispatch(
      addCoachingNotesListReq({
        module: _.isEmpty(coachObj)
          ? "addCoachingNotesData"
          : "editCoachingNotesData",
        postData: req,
      })
    );
  };

  useEffect(() => {
    console.log("addCoachingNotesListtRes: ", addCoachingNotesListRes);
    if (!_.isEmpty(addCoachingNotesListRes)) {
      if (addCoachingNotesListRes?.status === "success") {
        let response = addCoachingNotesListRes?.payload?.payload;
        dispatch(addCoachingNotesListReqResponseClear());
        refreshList();
        setIsFetching(false);
        setShowAddCoachModal(false);
      }
    }
  }, [addCoachingNotesListRes]);

  return (
    <Modal
      show={showAddCoachModal}
      onHide={() => {
        setShowAddCoachModal(false);
      }}
      dialogClassName="modal-60w"
      aria-labelledby="contained-modal-title-vcenter"
      className="alert-modal coaching-notes-modal"
      centered
    >
      {/* <Modal.Header closeButton className="modal-header">
            <Modal.Title>Favourite Delete Alert</Modal.Title>
        </Modal.Header> */}
      <Modal.Header closeButton>
        <h6>
          {_.isEmpty(coachObj) ? t("Add Coaching Note") : t("Edit Coaching Note")}
        </h6>
      </Modal.Header>
      <Modal.Body>
        <div className="">
          <Loader start={isFetching} />
          <div className="input-text">
            <label htmlFor="first_name" className="input__label">
              {t("Coaching Title")}*
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              className="input__field"
              placeholder="Enter your coaching title"
              value={title}
              onChange={(evt) => {
                setTitle(evt.target.value);
              }}
              disabled={isOther !== "1" || !isEdit ? true : false}
            />
          </div>
          {errorType === "title" && <p className="error-msg">{errorMsg}</p>}

          <div className="crateteamform">
            <div className="input-text position-relative">
              <label htmlFor="date_join" className="input__label">
                {t("Choose Date")}
              </label>
              <div className="date-warp position-relative">
                <DatePicker
                  id="idStartDate"
                  selected={startDate}
                  placeholderText="MM/DD/YYYY"
                  className="input__field"
                  defaultDate="MM/DD/YYYY"
                  minDate={new Date()}
                  disabled={isOther !== "1" || !isEdit ? true : false}
                  onChange={(date) => setStartDate(date)}
                />
                <span className="cal-date">
                  <svg
                    className="cursor-pointer"
                    onClick={() => {
                      document.getElementById("idStartDate").click();
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#000000"
                  >
                    <path d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"></path>
                  </svg>
                </span>
              </div>
              {errorType === "startDate" && (
                <p className="error-msg">{errorMsg}</p>
              )}
            </div>

            <div className="input-text">
              <label htmlFor="follow_up_title" className="input__label">
                {t("Follow-up Meeting Title")}*
              </label>
              <input
                type="text"
                id="follow_up_title"
                name="follow_up_title"
                className="input__field"
                placeholder="Enter your follow-up title"
                value={followUpTitle}
                onChange={(evt) => {
                  setFollowUpTitle(evt.target.value);
                }}
                disabled={isOther !== "1" || !isEdit ? true : false}
              />
              {errorType === "followTitle" && (
                <p className="error-msg mt-1">{errorMsg}</p>
              )}
            </div>

            <div className="input-text position-relative wrap-cal">
              <label htmlFor="date_join" className="input__label">
                {t("Follow-up")} Date
              </label>
              <div className="date-box-p">
                <div className="date-time-wrap">
                  <div className="date-warp position-relative">
                    <DatePicker
                      id="idFollowDate"
                      selected={followUpDate}
                      placeholderText="MM/DD/YYYY"
                      className="input__field"
                      defaultDate="MM/DD/YYYY"
                      minDate={new Date()}
                      disabled={isOther !== "1" || !isEdit ? true : false}
                      onChange={(date) => setFollowUpDate(date)}
                    />
                    <span className="cal-date">
                      <svg
                        className="cursor-pointer"
                        onClick={() => {
                          document.getElementById("idFollowDate").click();
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#000000"
                      >
                        <path d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"></path>
                      </svg>
                    </span>
                  </div>
                  {errorType === "followDate" && (
                    <p className="error-msg">{errorMsg}</p>
                  )}
                </div>
                <div className="timepicker">
                  <div className="startTime">
                    <div className="d-flex flex-column gap-2 end-time">
                      <label htmlFor="date_join" className="input__label">
                        {t("Start Hours")}
                      </label>
                      <select
                        className="form-select"
                        id="category"
                        aria-label="Default select example"
                        onChange={(ev) => {
                          setStartHour(ev.target.value);
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        {hour.map((cat, index) => {
                          return (
                            <option
                              key={index}
                              selected={startHour === cat ? true : false}
                            >
                              {cat}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="d-flex flex-column gap-2 end-time">
                      <label htmlFor="date_join" className="input__label">
                        {t("Start Minutes")}
                      </label>
                      <select
                        className="form-select"
                        id="category"
                        aria-label="Default select example"
                        onChange={(ev) => {
                          setStartMin(ev.target.value);
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        {min.map((cat, index) => {
                          return (
                            <option
                              key={index}
                              selected={startMin === cat ? true : false}
                            >
                              {cat}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="startTime">
                    <div className="d-flex flex-column gap-2 end-time">
                      <label htmlFor="date_join" className="input__label">
                        {t("End Hours")}
                      </label>
                      <select
                        className="form-select"
                        id="category"
                        aria-label="Default select example"
                        onChange={(ev) => {
                          setEndHour(ev.target.value);
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        {hour.map((cat, index) => {
                          return (
                            <option
                              key={index}
                              selected={endHour === cat ? true : false}
                            >
                              {cat}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="d-flex flex-column gap-2 end-time">
                      <label htmlFor="date_join" className="input__label">
                        {t("End Minutes")}
                      </label>
                      <select
                        className="form-select"
                        id="category"
                        aria-label="Default select example"
                        onChange={(ev) => {
                          setEndMin(ev.target.value);
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        {min.map((cat, index) => {
                          return (
                            <option
                              key={index}
                              selected={endMin === cat ? true : false}
                            >
                              {cat}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  {/*<input type="time" id="appt" name="appt" value={fromTime} onChange={(evt)=>{setFromTime(evt.target.value)}} />*/}
                  {/*<input type="time" id="appt" name="appt" value={toTime} onChange={(evt)=>{setToTime(evt.target.value)}}/>*/}
                </div>
              </div>

              {/* <TimePicker placeholder="From" defaultValue ="10:00" onTimeChange = {handleTimeChange}/>
                            <TimePicker placeholder="To" defaultValue ="10:00" onTimeChange = {handleToTimeChange}/> */}
            </div>
          </div>
          <div></div>

          {errorType === "dateValidation" && (
            <p className="error-msg">{errorMsg}</p>
          )}

          <div className="input-text">
            <label htmlFor="first_name" className="input__label">
              {t("Notes")}
            </label>
            <textarea
              type="text"
              id="first_name"
              name="first_name"
              className="input__field"
              placeholder="Enter notes"
              value={notes}
              onChange={(evt) => {
                setNotes(evt.target.value);
              }}
              disabled={isOther !== "1" || !isEdit ? true : false}
            ></textarea>
            {errorType === "notes" && <p className="error-msg">{errorMsg}</p>}
          </div>
        </div>
      </Modal.Body>
      {isOther === "1" && (
        <Modal.Footer className="justify-content-end gap-3">
          <Button
            variant="primary"
            onClick={() => {
              // if (_.isEmpty(coachObj)) {
              setShowAddCoachModal(false);
              // } else {
              //   setIsEdit(!isEdit);
              // }
            }}
          >
            {_.isEmpty(coachObj)
              ? t("cancel")
              : isEdit
              ? t("cancel")
              : t("cancel")}
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              addNotes();
            }}
          >
            {_.isEmpty(coachObj) ? t("Add Note") : t("save")}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CoachAddModal;
